import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';


import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import { Row, Col, Card, Tabs, Tab, Spinner, Badge, Modal, InputGroup } from 'react-bootstrap'
import Carousel from 'react-bootstrap/Carousel';



import { auth, firestore } from "../Database/firebase";
// import { AuthContext } from '../../Old_Test/Auth';

import { Link, Navigate, useNavigate } from "react-router-dom";

import { FaHeart, FaTruck, FaFacebookMessenger, FaSketch, FaRegHeart, FaRegCommentAlt, FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { BsStarFill, BsStarHalf, BsStar, BsEye, BsBookmark, BsChatSquareQuote, BsSearch } from "react-icons/bs";
import { text } from '@fortawesome/fontawesome-svg-core';
import { FcFlashOn } from "react-icons/fc";

import "../component_home/content/content.css";

const SearchBook = () => {

    

    const [data, setData] = useState([]);

    useEffect(() => {
        const bookRef = firestore.collection("product");
        const query = bookRef
        
        .orderBy("productName")
        .where("publicStatus", "==", 1)
        .startAt(queryBar.toUpperCase())
        .endAt(queryBar.toUpperCase() + "\uf8ff")
        
        .limit(8);
          /*   .where("publicStatus", "==", "เผยแพร่")
            .where("status", "==", "public"); */
            // .limit(8);
            // .where("productName", "<=", queryBar.toUpperCase() + "\uf8ff");
            
            /* .where("productName", ">=", queryBar.toUpperCase())
            .where("productName", "<=", queryBar.toUpperCase() + "\uf8ff"); */
                query
                .get()
                .then((querySnapshot) => {
                let tempDataArray =[];
                querySnapshot.forEach((doc) => {
                    if (doc.exists) {
                        tempDataArray = [...tempDataArray,
                        {

                            id: doc.id,
                                productID: doc.data().productID,
                                merchantName: doc.data().merchantName,
                                productName: doc.data().productName,
                                productImage: doc.data().productImage,
                                productFullPrice: doc.data().productFullPrice,
                                productPrice: doc.data().productPrice,
                                productCategory: doc.data().productCategory,
                    
                                productTypeCategory: doc.data().productTypeCategory,
    
                                productRatingSum: doc.data().productRatingSum,
                                productRatingCount: doc.data().productRatingCount,
    
                                saleCount: doc.data().saleCount,
    
                                publicStatus: doc.data().publicStatus,
                

                        },
                    ];

                    
                    };

            });
            setData((oldDataArray) => tempDataArray);
    },
        (err) => {
            console.log(err);
        }
    );

    }, [data]);
    
            /* useEffect(() => {
                const productRef = firestore.collection("product")
                .orderBy("productName")
                .where("publicStatus", "==", 1)
                .startAt(queryBar.toUpperCase())
                .endAt(queryBar.toUpperCase() + "\uf8ff")
                
                .limit(8);
            
                productRef.onSnapshot((snapshot) => {
                let tempDataArray =[];
                snapshot.forEach((doc) => {
    
                    if (doc.exists) {
    
                    tempDataArray = [...tempDataArray,
    
                            {
    
                                id: doc.id,
                                productID: doc.data().productID,
                                merchantName: doc.data().merchantName,
                                productName: doc.data().productName,
                                productImage: doc.data().productImage,
                                productFullPrice: doc.data().productFullPrice,
                                productPrice: doc.data().productPrice,
                                productCategory: doc.data().productCategory,
                    
                                productTypeCategory: doc.data().productTypeCategory,
    
                                productRatingSum: doc.data().productRatingSum,
                                productRatingCount: doc.data().productRatingCount,
    
                                saleCount: doc.data().saleCount,
    
                                publicStatus: doc.data().publicStatus,
    
                            },
    
                        ];
    
                    };
                });
    
                setData((oldDataArray) => tempDataArray);
    
                },
    
                (err) => {
    
                    console.log(err);
    
                }
    
                );
    
            }, [data]); */

            const [queryBar, setQueryBar] = useState("");

            function search(e){
                e.preventDefault();
                setQueryBar(e.target.value);
        
        
            }



    return (
        <Container>
      
        <br/>
        <h3 style={{fontWeight: 'bold'}}><strong><BsSearch/> ค้นหาหนังสือ</strong></h3>
        
        <br/>


        <InputGroup className="mb-3">
            
            <Form.Control
                type="text"
                placeholder= "ค้นหาหนังสือ..."
                onChange={search}
                value={queryBar}
            />
            <Button variant="outline-secondary" style={{borderColor: 'darkgray', borderLeft: 0}} disabled>
                <BsSearch/>
            </Button>
        </InputGroup>

      
        {/* <br/>
        <h4 style={{fontWeight: 'bold'}}><strong>หมวดหมู่หลัก</strong></h4><br/>
        <h3><span class="badge rounded-pill bg-light text-dark">อาญา</span> 
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>แพ่ง</span>  
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>วิอาญา</span> 
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>วิแพ่ง</span> 
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>วิอาญา</span>

        </h3>
        <br/> */}

        {/* <br/>
        <br/>
        <h4 style={{fontWeight: 'bold'}}><strong>หมวดหมู่รอง</strong></h4><br/>
        <h3><span class="badge rounded-pill bg-light text-dark">ประมวลกฎหมาย</span> 
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>พระราชบัญญัติ</span>  
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>กฎหมาย</span> 
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>หนังสือเรียน</span> 
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>เตรียมสอบ</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>เนติบัณฑิต</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>ทนายความ</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>อัยการ</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>ผู้พิพากษา</span>


        </h3> 
        <br/>
        <br/>
        <h4 style={{fontWeight: 'bold'}}><strong>หมวดหมู่ย่อย</strong></h4><br/>
        <h3><span class="badge rounded-pill bg-light text-dark">อาญา</span> 
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>แพ่ง</span>  
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>วิอาญา</span> 
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>วิแพ่ง</span> 
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>วิอาญา</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>ภาษี</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>ล้มละลาย</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>แรงงาน</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>พระธรรมนูญศาล</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>ปกครอง</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>รัฐธรรมนูญ</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>ภาษาอังกฤษ</span>
        </h3> 
        <br/> */}

        <br/>
        <br/>

        <Row xs={2} md={4} className="sm-4">

            {data.map((item) => {
                            
                return (
                               
                    <div key={item.id}>



                                <div>
                                                                    {/* <Link to={'/ReadArticle/'+ item.articleID} style={{textDecoration: 'none', color: "black"}}> */}
                                                                        <Card className="cardarticle">
                                
                                                                            {!!item.productImage ? (
                                                                                <Card.Img variant="top" class='cardarticledetailimg' style={{marginLeft: 'auto', marginRight: 'auto'}} src={item.productImage} />
                                                                            ) : (
                                                                                <Col style={{backgroundColor: '#FFFAFA'}}><div class='cardarticledetailnoimg'><strong>{(item.merchantName)}</strong></div></Col>
                                                                            )}
                                                                            
                                                                            
                                                                            <Card.Body class='cardarticledetail'>
                                                                                <Card.Title>
                                                                                </Card.Title>
                                
                                                                                <p class='articlename'>{item.productName}</p>
                                                                           
                                                                                {/* <p class='cardarticledetailnamedatetime'>{item.merchantName} <br/> {(item.articleDate).toDate().toLocaleDateString('th-TH', {year: 'numeric', month: 'short', day: 'numeric', weekday: 'short',})} | {(item.articleDate).toDate().toLocaleTimeString()}  */}
                                                                                <p class='cardarticledetailnamedatetime'>{item.merchantName} <br/> 
                                                                                <br/>
                                                                                </p>
                                                                             
                                                                                
                                                                                {/* <span class='cardarticledetaillikebookmark'><strong><FaRegHeart/> {item.likeCount}</strong><strong>&nbsp;&nbsp;<BsEye/> {item.viewCount + 1}</strong> <Badge style={{fontWeight: 'bold', marginTop: 5}} className="float-end rounded-pill" bg="light text-secondary">{item.articleCategory}</Badge></span></p> */}
                                   
                                                                                    
                                                                            </Card.Body>
                                                                        </Card>
                                                                    {/* </Link>  */}
                                                                </div>

                                    {/* ///////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}

                    </div>

                )
            })}

            </Row>


    

        <br/>
        <br/>
        
        </Container>
        
    );
};

export default SearchBook;